import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSystemConfig } from '../libs/db-lib';
import { RuntimeConfig } from '../types';
import { useUser } from './User';

export interface SystemConfigContextInterface {
  config: RuntimeConfig;
}

export const defaultConfig: RuntimeConfig = {
  baseUrl: '',
  braintreeMode: '',
  merchantId: '',
  plusBaseTechCerts: 0,
  standardBaseTechCerts: 0,
  prices: {},
  plusBaseUsers: 0,
  standardBaseUsers: 0,
};

export const SystemConfigContext = createContext<SystemConfigContextInterface>({
  config: defaultConfig,
});

export const useSystemConfig = () => {
  return useContext(SystemConfigContext);
};

type SystemConfigProviderType = {
  children: JSX.Element;
};

export function SystemConfigProvider({ children }: SystemConfigProviderType) {
  const { user } = useUser();

  const [config, setConfig] = useState<RuntimeConfig>(defaultConfig);

  useEffect(() => {
    const fetchConfig = async () => {
      const response = await getSystemConfig();
      if (!response?.error) {
        setConfig(response);
      } else {
        console.error('Failed to get system config', response.error);
      }
    };

    if (user) {
      fetchConfig();
    }
  }, [user]);

  const provider = { config };

  return (
    <SystemConfigContext.Provider value={provider}>
      {children}
    </SystemConfigContext.Provider>
  );
}
